import { TinyYolov2 } from './TinyYolov2';
export * from './TinyYolov2Options';
export * from './config';
export { TinyYolov2 };
export function createTinyYolov2(weights, withSeparableConvs) {
    if (withSeparableConvs === void 0) { withSeparableConvs = true; }
    var net = new TinyYolov2(withSeparableConvs);
    net.extractWeights(weights);
    return net;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/tinyYolov2/index.js
// module id = 317
// module chunks = 0